// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3bnPd","errorLogs":"EditorFooter_errorLogs__3k5RP"};